import { Box, Paper, Tab } from "@mui/material";
import { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';

import DashboardTab from "./DashboardTab";
import RequestsTab from "./RequestsTab";
import ApprovalsTab from "./ApprovalsTab";
import { useSelector } from "react-redux";

const HiringRequestLandingPage = () => {
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get("tab");
    const [value, setValue] = useState(tabParam ? tabParam : "dashboard");
    const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
    const atsMPRApproverAccess = atsModuleData?.find((item) => item.module_name === "MPR Approver");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tab = params.get("tab");
        if (tab !== null) {
            setValue(tab);
        } else {
            setValue("dashboard");
            history.replace({
                pathname: location.pathname,
                search: `?tab=dashboard`
            });
        }
    }, [location.search, location.pathname, history]);
 
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        history.push({
            pathname: location.pathname,
            search: `?tab=${newValue}`
        });
    };

    return (
        <Base>
            <Box sx={{ minHeight: "calc(100vh - 65px)",
                        maxHeight: "calc(100vh - 65px)", overflowY: 'auto' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    sx={{
                        minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                        '& .MuiTabs-indicator': {
                            width: '100%',
                            display: 'flex',
                            justifyContent: "center !important",
                        },
                        mb: 0.5
                    }} 
                    >
                    <Tab label="Dashboard" value="dashboard" {...a11yProps("dashboard")} />
                    <Tab label="Requests" value="requests" {...a11yProps("requests")} />
                    {atsMPRApproverAccess && ( 
                      <Tab label="Approvals" value="approvals" {...a11yProps("approvals")} />)}
                </Tabs>
                <TabPanel value={value} index="dashboard">
                    <DashboardTab />
                </TabPanel>
                <TabPanel value={value} index="requests">
                    <RequestsTab />
                </TabPanel>
                <TabPanel value={value} index="approvals">
                    <ApprovalsTab />
                </TabPanel>
            </Box>
        </Base>
    )
}
export default HiringRequestLandingPage;
